<template>
  <svg
    clip-rule="evenodd"
    stroke-linejoin="round"
    stroke-miterlimit="1.4142"
    version="1.1"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m19 20h-15c-1.11 0-2-0.9-2-2v-12c0-1.11 0.89-2 2-2h6l2 2h7c1.097 0 2 0.903 2 2h-17v10l2.14-8h17.07l-2.28 8.5c-0.23 0.87-1.01 1.5-1.93 1.5z"
      class="folder-icon"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
  },
};
</script>

<style lang="scss" scoped>
.folder-icon {
  fill: #8a8880;
}
</style>
